import * as React from 'react';
import { useField } from 'formik';

import { Label } from '../Label';

import styles from '../forms.module.css';

interface NumberProps {
    label?: string;
    id: string;
    name: string;
    required?: boolean;
    fullWidth?: boolean;
    hideError?: boolean;
}

export const Number: React.FC<NumberProps> = ({ id, label, required = false, fullWidth = false, hideError, ...props }) => {
    const [field, meta] = useField(props as any);

    return (
        <>
            {label && <Label label={label} id={id} required={required} />}
            <input className={styles.InputElement} type="number" style={{ width: fullWidth ? '100%' : 'auto' }} {...field} />
            {!hideError && meta.touched && meta.error && <div className={styles.Error}>{<span>{meta.error}</span>}</div>}
        </>
    );
};
